import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { MonoLabel } from '../components/Editorial';
import Button from '../components/Button';

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      await axios.post('/api/auth/forgot-password', { email });
      setSubmitted(true);
    } catch (err) {
      setError('Something went wrong. Please try again.');
    }
    setLoading(false);
  };

  return (
    <div className="ed-auth">
      <div className="ed-auth__hero">
        <div>
          <MonoLabel onDark>RESET ACCESS</MonoLabel>
          <h1 className="ed-auth__hero-headline" style={{ marginTop: 16 }}>
            Lost the<br /><em>password.</em>
          </h1>
        </div>
        <p className="ed-auth__hero-quote">
          "We'll get you back in. Drop your email and we'll send a fresh reset link."
        </p>
      </div>

      <div className="ed-auth__form-wrap">
        <div className="ed-auth__form">
        <div className="auth-logo" style={{ marginBottom: 24 }}>
          <img src="/logo.png" alt="ProZpects" style={{ maxHeight: 36 }} />
        </div>
        <MonoLabel>RESET PASSWORD</MonoLabel>
        <h2 style={{ fontFamily: 'var(--ed-font-serif)', fontSize: 36, fontWeight: 400, letterSpacing: '-0.015em', margin: '8px 0 12px' }}>
          Forgot password.
        </h2>
        <div className="auth-subtitle">
          Enter your email and we'll send you a reset link.
        </div>

        {submitted ? (
          <div className="auth-success" role="alert">
            If an account exists with that email, we've sent a reset link.
            Check your inbox.
          </div>
        ) : (
          <form className="auth-form" onSubmit={handleSubmit}>
            {error && <div className="auth-error" role="alert">{error}</div>}

            <div className="auth-field">
              <label htmlFor="forgot-email">Email</label>
              <input
                id="forgot-email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>

            <Button type="submit" variant="primary" className="auth-btn" disabled={loading}>
              {loading ? 'Sending...' : 'Send Reset Link'}
            </Button>
          </form>
        )}

        <div className="auth-footer">
          <Link to="/login">Back to login</Link>
        </div>
        </div>
      </div>
    </div>
  );
}
